import type { PropsWithChildren } from 'react';

import { Button } from '../ui/button.tsx';

type Props = {
    key: string;
    isSelected: boolean;
    onClick: () => void;
} & PropsWithChildren;
export function QuickFilterButton({ children, isSelected, onClick }: Props) {
    return (
        <Button variant="quick-filter" onClick={onClick} selected={isSelected}>
            {children}
        </Button>
    );
}
